import script from "./AccessDenied.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccessDenied.vue?vue&type=script&setup=true&lang=ts"

import "./AccessDenied.vue?vue&type=style&index=0&id=29084ef4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29084ef4"]])

export default __exports__